<template>
  <div>
    <a-drawer :title="`转赠落地页`" :width="850" :visible="showHandselForm" :body-style="{ paddingBottom: '80px' }"
      @close="close">

      <a-form-model ref="form"  :model="model" :rules="rules" >

        <a-spin :spinning="loading" tip="Loading..." size="large">
       
        <a-form-model-item label="转赠的落地页" prop="site_id" help=''>
          <a-select v-model="model.site_id">
            <a-select-option :value="item.out_id" v-for="item in model.landingPages" :key="item.out_id" :disabled="['auditAccepted', 'AUDIT_ACCEPTED', 'AUDIT_DOING', 'ENABLE'].includes(item.status)?false:true">
                {{ item.name }}【{{item.status === 'auditAccepted' || item.status === 'AUDIT_ACCEPTED' ? '正常' : (item.status === 'edit' ? '未发布' : (item.status === 'enable' ? '已发布' : '未知'))}}】
            </a-select-option>
            </a-select>
        </a-form-model-item>

        <a-form-model-item label="被转赠的广告主" help=''>
          <a-input :value="item.advertiser_name" disabled v-for="item in model.advertisers" :key="item.advertiser_id"/>
        </a-form-model-item>

        <a-form-model-item v-if="advertisersSelect.length > 0 && showSelectApps" label=""  help='' style="border: 1px solid #87e8de;;padding:20px">
          <b style="color:red">以下广告主有多资产，需要确认</b>
          <a-tabs :default-active-key="0" size="small" tabPosition="left"  :style="{ height: '500px' }">

            <a-tab-pane  :tab="advertiser.advertiser_name" v-for="(advertiser,index) in advertisersSelect" :key="index" >
              
              <a-form-model-item label="巨量引擎广告主ID">
                 <a-input v-model="advertisers[advertiser.index].advertiser_id" disabled />
              </a-form-model-item> 
              
              <a-form-model-item label="微信小程序资产ID">
                <a-select v-model="advertisers[advertiser.index].instance_id" placeholder="请选择小程序资产" @change="changeApp">
                  <a-select-option :value="item.instance_id" v-for="item in advertiser.apps" :key="item.id" :app="item" :index="advertiser.index">
                    {{ item.name }} - {{ item.create_time }}
                  </a-select-option>
                 </a-select>

                <a-card v-if="advertisers[advertiser.index].appShow.id" size="small" :title="advertisers[advertiser.index].appShow.name" style="background:#ECECEC">
                  <p>小程序资产ID：{{advertisers[advertiser.index].appShow.instance_id}}</p>
                  <p>原始ID：{{advertisers[advertiser.index].appShow.user_name}}</p>
                  <p>路径参数：{{advertisers[advertiser.index].appShow.path}}</p>
                </a-card>

              </a-form-model-item>

              <a-form-model-item label="小程序路径参数" v-if="advertisers[advertiser.index].instance_id">
                 <a-input v-model="advertisers[advertiser.index].path" />
              </a-form-model-item>
             
            </a-tab-pane>

          </a-tabs>
      </a-form-model-item>

        <div class="result" v-if="result.success.length + result.errors.length > 0">
          <div v-for="(item, index) in result.success" :key="'s' + index">{{ item }}-创建成功</div>
          <div class="text-red" v-for="(item, index) in result.errors" :key="'e' + index">{{ item }}</div>
        </div>
      </a-spin>
      </a-form-model>

      <div v-if="showSubmit" :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }">
        <a-button @click="close" :disabled="loading" :style="{ marginRight: '8px' }">
          取消
        </a-button>
        <a-button type="primary" @click="submit" :disabled="loading">确定</a-button>
      </div>


      <a-modal :visible="showResult" :footer="null" @cancel="closerResult"  centered :title="`批量转赠落地页结果`" :width="'50%'">
          <div style="min-height:300px">
            <div v-for="(item, index) in result.success" :key="'s' + index">{{ item }}-创建成功</div>
            <div class="text-red" v-for="(item, index) in result.errors" :key="'e' + index">{{ item }}</div>
          </div>
      </a-modal>

    </a-drawer>
  </div>
</template>

<style lang="less" scoped>
@import 'CreateHandsel';
</style>

<script>
import CreateHandsel from './CreateHandsel'

export default CreateHandsel
</script>
